<div *ngIf="user" class="border-bottom pb-4 pt-4 mb-2">
  <div class="d-flex align-items-center mb-2">
    <tr-icon [icon]="icon.settings2" [size]="size.extraLarge" class="mr-3"></tr-icon>
    <h2 class="m-0">Reserve with Google</h2>
  </div>

  <form [formGroup]="form" (submit)="save()" class="pl-5">
    <div class="row form-group">
      <p>Connect your public waitlist to Google so people can join your waitlist directly from various Google properties (primarily Google Maps results).</p>
      <p>In order to enable this, you must be a restaurant, your Public Waitlist Add mode must be enabled, you must also provide your physical address and website URL in Account Settings, enable Waitlist Confirmation SMS and Waitlist Cancelation SMS.</p>
      <p>We also recommend setting the hours you'll accept online check-ins by configuring your <a [routerLink]="'/settings/preferences/schedules'">Schedule</a> and assigning it to your <a [routerLink]="'/settings/preferences/public-pages'">Public Waitlist</a>. You should also set your max party size for online check-ins on your <a [routerLink]="'/settings/preferences/public-pages'">Public Options</a> page.</p>
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="google-reservation-enabled" class="col-form-label">Enable</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 mt-2">
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              id="google-reservation-enabled"
              name="enabled"
              formControlName="enabled"
            >Enable
          </label>
        </div>
      </div>
    </div>

    <button
      class="btn btn-success"
      [disabled]="form.invalid || sending || form.pristine"
      style="width: 89px;"
    >Save</button>
  </form>
</div>
